export const SET_DELETE_PASSENGER_FROM_MULTIPLE_FLIGHTS =
  'SET_DELETE_PASSENGER_FROM_MULTIPLE_FLIGHTS'

export default () => ({
  type: SET_DELETE_PASSENGER_FROM_MULTIPLE_FLIGHTS,
})
